import React, { useState, useRef, useEffect } from 'react';
import PropTypes   from 'prop-types';
import { isEmpty } from 'lodash';
import BeatLoader  from 'react-spinners/BeatLoader';

import { getStripeConnectAuth, unsyncStripeConnect } from '~/../components/shared/utils/api';

import { toDollars, toCents } from '~/../components/shared/utils/helpers';

const SetupPaywall = ({ formData, handleFieldChange, errors, params, setFormData }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [feedback, setFeedback] = useState({});
  const feedbackTimer = useRef(null);
  const isConnected = !isEmpty(formData.stripe_connect_account_id);
  const [fee, setFee] = useState(toDollars(formData.monthly_price_in_cents));

  useEffect(() => {
    const stripeCall = params.stripe_success;

    if(!isEmpty(stripeCall) && stripeCall === 'true') {
      handleFeedback({ msg: 'Successfully connected.', msgColor: 'green' })
    }
    else if (!isEmpty(stripeCall) && stripeCall === 'false') {
      handleFeedback({ msg: 'Failed to connect. Please try again.', msgColor: 'red' })
    }

    return () => clearTimeout(feedbackTimer.current);
  }, []);

  const handleStripeSuccess = data => {
    setIsLoading(false);
    window.location.replace(data.url);
  };

  const handleFeedback = feedback => {
    setFeedback(feedback)
    feedbackTimer.current = setTimeout(() => setFeedback({}), 7000);
  }

  const handleStripeFailure = ({ errors }) => {
    setIsLoading(false);
    handleFeedback({ msg: errors, msgColor: 'red' })
  };

  const handleStripeConnect = () => {
    setIsLoading(true);
    getStripeConnectAuth(formData.slug, handleStripeSuccess, handleStripeFailure);
  }

  const renderStripeButtonTitle = () => {
    if (isConnected && !isEmpty(formData.connected_to)) {
      return <p className='mt-5'>Connected to <span className='w3'>{formData.connected_to}</span></p>;
    }
    else if (isConnected && isEmpty(formData.connected_to)) {
      return <p className='mt-5'>Connected</p>;
    }
    else return <p className='mt-5'>Connect with <span className='w3'>Stripe</span></p>;
  }

  const handleUnsync = () => {
    if (confirm('Are you sure you want to unsync this account?')) {
      unsyncStripeConnect(formData.slug, (community) => setFormData(community))
    }
  };

  const handleFeeChange = e => {
    const { name } = e.target;
    let value = e.target.value;
    if (value.indexOf('$') != 0) value = '$' + value;
    setFee(value);
    handleFieldChange({ target: { name, value: toCents(value) } });
  }

  return (
    <div className='ml-20'>
      <p className='fs-23 w3'>Charge a membership fee for access</p>

      <p className='fs-15 w3 mt-50'>Connect a Stripe account</p>
      <p className='t4 w2 mt-5'>
        Charge for your community via subscriptions or one-time payments.
        Voray uses Stripe to securely process payments.
      </p>
      <p className='t4 w2'>
        To accept payments on your community,
        please connect your Stripe account.
      </p>

      <div className='mt-30'>
        <button
          className='btn stripe-connect-btn'
          disabled={isConnected}
          onClick={isConnected ? () => {} : () => handleStripeConnect() }
        >
          {renderStripeButtonTitle()}
        </button>
        { isConnected && <i class='fa fa-times ml-5 pointer unsync-btn' onClick={handleUnsync}/>}
        { !isEmpty(feedback) && <span className={`${feedback.msgColor} mt-5 block`}>{feedback.msg}</span>}
        { isLoading && <BeatLoader color='#5b33e9' speedMultiplier={0.5} className='mt-10'/>}
      </div>

      <label className='mt-30 fs-15 w3 block'>Set a monthly membership fee</label>
      <input
        className='form-control mt-5 w-30r'
        name='monthly_price_in_cents'
        value={fee}
        onChange={handleFeeChange}
        placeholder='$0.00'
      />
      {errors.monthlyPriceInCents && <p className='field-error'>{errors.monthlyPriceInCents}</p>}
      <p className='t4 w2 mt-10'>
        This will be a monthly fee charged to customers. An annual option will be automatically
        offered which will give them 2 months free of charge. Public communities with a membership
        fee will have content locks.
      </p>
    </div>
  );
};

SetupPaywall.propTypes = {
  formData: PropTypes.object.isRequired,
  handleFieldChange: PropTypes.func.isRequired
};

export default SetupPaywall;
